import { makeStyles } from "@material-ui/core/styles";

const AddNewULDStyle = makeStyles({
  AddNewItemWrapper: {
    "& button.primary-btn.orange-btn": {
      height: "45px",
      lineHeight: "45px",
      marginRight: "15px",
      fontWeight: "600",
      fontSize: "16px",
      width: "100%",
    },
  },
});

export { AddNewULDStyle };
